import AccommodateScrollBarBoxCode from "!!raw-loader!./boxes/AccommodateScrollBarBox.tsx";
import AspectCode from "!!raw-loader!./boxes/Aspect.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import AccommodateScrollBarBox from "./boxes/AccommodateScrollBarBox";
import Aspect from "./boxes/Aspect";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Aspect Boxes", AspectCode, Aspect),
		paneComponent("Accommodate scrollbar Box", AccommodateScrollBarBoxCode, AccommodateScrollBarBox, "This component is used for handle the case where the scrollbar causes an issue, something like flicker issue"),
	];

	return (
		<Pane
			components={components}
			imports='import {Box} from "designSystem/index";'
			muiApi="box"
			muiComponent="box"
			{...props}
		/>
	);
};